import {Utils, ApiClientCommunication} from 'neo-common';
import {IBalance} from '../Types/IBalance';

export class BalanceResponse extends ApiClientCommunication.ResponseBase implements IBalance {
    /**
     * @property real - real money balance in cents
     */
    real: number;

    /**
     * @property bonus - bonus points balance in cents
     */
    bonus: number;

    protected internalValidate(errors: Array<string>): void {
        if (Utils.isNullOrUndefined(this.real)) {
            errors.push('Property "real" is missing or has null/undefined value!');
        }

        if (Utils.isNullOrUndefined(this.bonus)) {
            errors.push('Property "bonus" is missing or has null/undefined value!');
        }
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Communication/Game/Responses/BalanceResponse.ts
 **/